<template>
    <div class="store-budgets" id="store-budgets">
        <el-card class="box-card">
            <div slot="header" class="text-left">
                <div class="row center-align-vert">
                    <div class="col-4 text-left">
                        <h4>Stores</h4>
                    </div>
                    <div class="col-8 text-right" >
                        <el-button v-if="noBudgetsOpen === false" plain type="primary" @click="saveBudgetAndPrediction" :loading="saving" :disabled=saveButtonDisabled>Next</el-button>
                        <el-button v-else class="ml-5-howrly" type="primary" disabled plain icon="el-icon-lock">Locked</el-button>
                    </div>
                </div>
            </div>

            <el-table :data="tableData" row-key="id" :row-class-name="tableRowClassName" @row-click="rowClicked" ref="storesTable">
                <el-table-column
                    sortable
                    label='Store'
                >
                    <template slot-scope="scope">
                        {{getStoreName(scope.row.Store)}}
                        <font-awesome-icon v-if="scope.row.child === false" size="1x" icon="info-circle" aria-hidden="true" v-b-popover.hover.right="getStoreContext(scope.row.Store)" variant="primary"/>
                    </template>
                </el-table-column>
                <el-table-column
                    v-for="col in tableHeaders"
                    :key="col"
                    :prop="col"
                    :label="col"
                    :formatter="formatter"
                    sortable
                >
                </el-table-column>
                <el-table-column
                    sortable
                    label='Adjusted'
                >
                    <template slot-scope="scope" v-if="scope.row" >
                        <span v-if="scope.row.child === false">
                            <el-badge v-model="badgeValues[scope.row.Store]"  class="item" :type="hoursManuallyChanged(scope.row.Store) === false ? 'primary' : 'info'">
                                <el-input :class="($store.state.budget.budget.find(x => x.store_id === parseInt(scope.row.Store)).min_hours > $store.state.budget.budget.find(x => x.store_id === parseInt(scope.row.Store)).hours) ? 'small-input vertical-align-center below-minimum' : 'small-input vertical-align-center'" :id=scope.row.Store :name="'storeHours'+scope.row.Store" v-validate.initial="'min_value:0'" :disabled="saveButtonDisabled === true || budgetOpen(scope.row) === false || $store.state.budget.savedByUser === true" placeholder="Hours" v-model="$store.state.budget.budget.find(x => x.store_id === scope.row.Store).hours" @change="hoursChanged($event, scope.row.Store)"></el-input>
                            </el-badge>
                        </span>
                        <span v-else><span v-if="scope.row.Store.includes('revenue')">€</span>{{scope.row.Adjusted.toLocaleString('en-EN', { maximumFractionDigits: 0 })}}</span>
                    </template>
                </el-table-column>
                <el-table-column label='Actions'>
                    <template slot-scope="scope">
                        <button @click.stop v-if="scope.row.child === false" :disabled="saveButtonDisabled" @click="revertBudgetChange($event,scope.row.Store)" type="button" class="btn btn-primary btn-circle"><font-awesome-icon size="1x" icon="undo"/></button>
                        <button @click.stop v-if="scope.row.child === false" :disabled="saveButtonDisabled" @click="decrease($event,scope.row.Store)" type="button" class="btn btn-circle btn-grey ml-5-howrly"><font-awesome-icon class="icon-button" size="1x" icon="minus-circle"/> </button>
                        <button @click.stop v-if="scope.row.child === false" :disabled="saveButtonDisabled" @click="increase($event,scope.row.Store)" type="button" class="btn btn-circle btn-grey ml-5-howrly"><font-awesome-icon class="icon-button" size="1x" icon="plus-circle"/> </button>
                        <span v-if="scope.row.child === false && errors.has('storeHours'+scope.row.Store) && saveButtonDisabled === false" class="help is-danger ml-10">Hours must be positive</span>
                        <span class="ml-10" v-if="scope.row.child === false && $store.state.budget.minimumCorrected.includes(scope.row.Store)">Hours have been corrected</span>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
    </div>
</template>

<script>
import { formatString } from '../../functions'
import vue from 'vue'

export default {
    props: ['saveButtonDisabled'],
    data () {
        return {
            tableHeaders: ['Last year', 'Predicted'],
            saved: false,
            saving: false,
            badgeValues: {},
            savingError: false,
            noBudgetsOpen: false
        }
    },
    watch: {
        saveButtonDisabled: function (newVal, oldVal) {
            setTimeout(() => vue.set(this.$store.state.budget, 'minimumCorrected', []), 10000)
        }
    },
    computed: {
        tableData () {
            let data = []
            for (let i = 0; i < this.$store.state.budget.budget.length; i++) {
                data[i] = {}
                data[i]['child'] = false
                data[i]['id'] = this.$store.state.budget.budget[i].store_id
                data[i]['Store'] = this.$store.state.budget.budget[i].store_id
                data[i]['Predicted'] = this.$store.state.budget.budget[i].hours_last_level
                data[i]['Last year'] = this.$store.state.budget.budget[i].hours_ly
                data[i]['Adjusted'] = this.$store.state.budget.budget[i].hours
                data[i]['children'] = []

                // Get the prediction that belongs to this budget
                let prediction = this.$store.state.budget.prediction.find(x => x.store_id === data[i]['Store'])
                let rowCount = 0
                for (let item in prediction['dataload']) {
                    if (this.$store.state.budget.commercialBudgetVariables.includes(item)) {
                        rowCount += 1
                        data[i]['children'].push({ 'child': true, 'id': String(data[i]['Store']) + '-' + String(rowCount), 'Store': formatString(item), 'Predicted': prediction['dataload_last_level'][item], 'Adjusted': prediction['dataload'][item], 'Last year': prediction['dataload_ly'][item] })
                    }
                }
            }
            this.updateBadgeValues()
            return data
        }
    },

    methods: {
        anyBudgetsOpen () {
            // If there is any underlying budget that is open, you can change this
            for (let b of this.$store.state.budget.budget) {
                if (b.budget_open === true) {
                    return true
                }
            }
            return false
        },
        budgetOpen (row) {
            return this.$store.state.budget.budget.find(x => x.store_id === parseInt(row['Store'])).budget_open
        },
        hoursManuallyChanged (store) {
            // Helper function to check if budget has been manually changed for a store
            if (this.$store.state.budget.manualTotalHourChange[store] === 0) {
                return false
            } else {
                return true
            }
        },
        increase (event, store) {
            // Increase button (+) is clicked for a store budget
            let budget = this.$store.state.budget.budget.find(x => x.store_id === store)
            let idx = this.$store.state.budget.budget.indexOf(budget)
            this.$store.dispatch('budget/updateStoreHours', { 'idx': idx, 'factor': 1.02 }).then(response => {
                this.$store.commit('budget/SET_PREDICTION_SUMS')
                this.updateBadgeValues()
                this.$emit('storeBudgetChanged')
            })
        },
        decrease (event, store) {
            // Decrease button (-) is clicked for a store budget
            let budget = this.$store.state.budget.budget.find(x => x.store_id === store)
            let idx = this.$store.state.budget.budget.indexOf(budget)
            this.$store.dispatch('budget/updateStoreHours', { 'idx': idx, 'factor': 0.98 }).then(response => {
                this.$store.commit('budget/SET_PREDICTION_SUMS')
                this.updateBadgeValues()
                this.$emit('storeBudgetChanged')
            })
        },
        formatter (row, column) {
            if (row[column.property] !== undefined && row[column.property] !== null) {
                if (row['Store'] !== undefined && row['Store'] !== parseInt(row['Store'])) {
                    if (row['Store'].includes('revenue')) {
                        return '€' + row[column.property].toLocaleString('en-EN', { maximumFractionDigits: 0 })
                    }
                }
                return row[column.property].toLocaleString('en-EN', { maximumFractionDigits: 0 })
            }
        },
        tableRowClassName ({ row, rowIndex }) {
            if (row.child === true) {
                return 'highlight-row'
            }
        },
        getStoreContext (store) {
            if (this.$store.state.budget.contextStoreBudgets.length > 0) {
                let context = this.$store.state.budget.contextStoreBudgets.find(x => x['Store id'] === store)
                if (context['Target CTR'] !== null && context['Target KPU'] !== null) {
                    return {
                        html: true,
                        content: () => {
                            return 'Surface: <em>' + context['Surface'] + '</em><br>Minimum hours: <em>' + this.$store.state.budget.budget.find(x => x.store_id === store).min_hours + '</em><br>Target KPU: <em>' + context['Target KPU'] + '</em><br>' + 'Target CTR: <em>' + context['Target CTR'] + '</em><br>'
                        }
                    }
                } else {
                    return {
                        html: true,
                        content: () => {
                            return 'Surface: <em>' + context['Surface'] + '</em><br>Minimum hours: <em>' + this.$store.state.budget.budget.find(x => x.store_id === store).min_hours + '</em><br>'
                        }
                    }
                }
            }
        },
        rowClicked (row) {
            var el = document.getElementById(row.Store)
            if (el !== document.activeElement) {
                try {
                    this.$refs.storesTable.toggleRowExpansion(row)
                } catch (error) {
                    // Only expand parent rows
                }
            }
        },
        saveBudgetAndPrediction () {
            this.saving = true
            // Correct budgets that are under min hours
            this.$store.dispatch('budget/correctMinimum').then(response => {
                this.$store.commit('budget/SET_PREDICTION_SUMS') // Set the new sums now that minimum may have been corrected
                this.updateBadgeValues() // Update the total hours badge in case hours has been corrected
                this.saving = false
                if (this.$store.state.budget.savingError === false) { // Check if saving in vuex went without errors
                    this.saved = true
                    this.$emit('saved')
                    this.$emit('storeBudgetChanged')
                    document.getElementById('budget-summary').scrollIntoView({
                        behavior: 'smooth'
                    })
                } else {
                    this.savingError = true
                    // eslint-disable-next-line
                        setTimeout(() => this.savingError = false, 5000)
                }
            })
        },
        hoursChanged (value, store) {
            // This function is called when someone changes an individual store budget
            // We first update the manual hour changes which checks for the minimum and then update the sums
            let factor = value / this.$store.state.budget.budget.find(x => x.store_id === store).hours_last_level
            this.$store.commit('budget/SET_MANUAL_HOUR_CHANGES', { 'factor': factor, 'updateHours': false, 'correctMinimum': false, 'store_id': store })
            this.$store.commit('budget/SET_PREDICTION_SUMS')
            this.updateBadgeValues()
            this.$emit('storeBudgetChanged')
        },
        updateBadgeValues () {
            // Helper function to update all badge values
            for (let b of this.$store.state.budget.budget) {
                let store = b['store_id']
                let badgeValue = b.hours - b.hours_last_level
                if (badgeValue > 0) {
                    vue.set(this.badgeValues, store, '+' + String(badgeValue.toFixed()) + ' hours')
                } else {
                    vue.set(this.badgeValues, store, String(badgeValue.toFixed()) + ' hours')
                }
            }
        },
        calculateAdjustedBudget () {
            // Function used to calculate the adjusted budget (so given all dataloads of the predictions)
            var budget = 0
            for (let param of this.$store.state.budget.regressionParameters) {
                if (param.type === 'commercial') {
                    for (let p of this.$store.state.budget.prediction) {
                        budget += param.coefficient * Math.pow(p.dataload[param.name], param.transform)
                    }
                } else {
                    for (let b of this.$store.state.budget.budget) {
                        budget += param.coefficient * Math.pow(b.dataload_store[param.name], param.transform)
                    }
                }
            }
            return budget
        },
        revertBudgetChange (event, store) {
            // Revert a budget change on store level (revert button is pressed)
            for (let i in this.$store.state.budget.budget) {
                if (this.$store.state.budget.budget[i]['store_id'] === store) {
                    vue.set(this.$store.state.budget.budget[i], 'hours', this.$store.state.budget.budget[i]['hours_last_level'])
                    vue.set(this.$store.state.budget.manualTotalHourChange, store, 0)
                }
            }
            this.$store.commit('budget/SET_PREDICTION_SUMS')
            this.$emit('storeBudgetChanged')

            // Remove the erorr message (apparently this only reacts to changes in the input field not underlying data)
            if (this.errors.has('storHours' + store)) {
                var idx = this.errors.items.indexOf(this.errors.items.find(x => x.field === 'storeHours' + store))
            }
            this.errors.items.splice(idx, 1)
        },
        getStoreName (id) {
            // Helper function to transform store id into store name
            let obj = this.$store.state.budget.contextStoreBudgets.find(x => x['Store id'] === parseInt(id))
            try {
                return obj['Store name']
            } catch (error) {
                return id
            }
        }
    },

    mounted () {
        this.updateBadgeValues()
        if (this.anyBudgetsOpen() === false) {
            this.noBudgetsOpen = true
        }
    }
}
</script>

<style lang="scss">
.store-budgets {
    .small-input {
        width: 100px;
    }
    .el-table .highlight-row {
        background: oldlace;
    }
    .el-button {
        margin-left: 10px;
    }
    .item {
        margin-top: 10px;
        margin-right: 40px;
    }
    .below-minimum {
        .el-input__inner {
            border: 1px solid red;
        }
    }
}
</style>
